<template>
  <div>
    <form>
      <v-row>
        <v-col
          cols="12"
          sm="6"
        >
          <v-text-field
            v-if="form.type == 'CR'"
            v-model="form.score"
            label="Celkové hodnotenie - počet bodov (min. 0 max. 106):"
            readonly
          />
          <v-text-field
            v-if="form.type == 'RU'"
            v-model="form.score"
            label="Celkové hodnotenie - počet bodov (min. 0 max. 110):"
            readonly
          />
        </v-col>

        <v-col
          cols="12"
          sm="6"
        >
          <v-text-field
            v-model="score_percentage"
            label="Celkové hodnotenie - % vyjadrenie (min. 0 max. 100 %):"
            readonly
          />
        </v-col>

        <v-col
          cols="12"
          sm="6"
        >
          <v-text-field
            v-model="score_text"
            label="Riziko recidívy trestnej činnosti/resocializačná prognóza:"
            readonly
          />
        </v-col>
      </v-row>

      <v-layout
        wrap
        pt-5
      >
        <v-flex xs12>
          <v-subheader class="pl-0">
            Skóre
          </v-subheader>
          <v-slider
            v-if="form.type == 'RU'"
            v-model="form.score"
            min="-1"
            max="110"
            :color="color"
            thumb-label="always"
            :thumb-color="color"
            readonly
          />
          <v-slider
            v-if="form.type == 'CR'"
            v-model="form.score"
            min="-1"
            max="106"
            :color="color"
            thumb-label="always"
            :thumb-color="color"
            readonly
          />
        </v-flex>
      </v-layout>
      <v-subheader>Hodnotitelia</v-subheader>
      <v-divider />
      <v-row>
        <v-col
          cols="12"
          sm="6"
        >
          <v-text-field
            v-model="form.assigned_to_socialny_pracovnik_full.string_details"
            label="Sociálny pracovník"
            readonly
          />
        </v-col>
        <v-col
          cols="12"
          sm="6"
        >
          <v-text-field
            v-model="form.assigned_to_pedagog_full.string_details"
            label="Pedagóg"
            readonly
          />
        </v-col>
        <v-col
          cols="12"
          sm="6"
        >
          <v-text-field
            v-model="form.assigned_to_psycholog_full.string_details"
            label="Psychológ"
            readonly
          />
        </v-col>
        <v-col
          cols="12"
          sm="6"
        >
          <v-text-field
            v-model="form.assigned_to_pbs_full.string_details"
            label="Prílušník PBS"
            readonly
          />
        </v-col>
        <v-col
          cols="12"
          sm="6"
        >
          <v-text-field
            v-model="form.assigned_to_pripadovy_manazer_full.string_details"
            label="Prípadový manažér"
            readonly
          />
        </v-col>
        <v-col
          cols="12"
          sm="6"
        >
          <v-text-field
            v-if="form.type == 'RU'"
            v-model="form.assigned_to_socialny_kurator_full.string_details"
            label="Sociálny kurátor"
            readonly
          />
        </v-col>
      </v-row>
      <!-- <div class="text-center">
        <v-btn @click="makePdf" class="ma-5" x-large color="primary">
          <v-icon left>mdi-file-pdf</v-icon>Exportovať ako PDF
        </v-btn>
      </div>-->
    </form>
  </div>
</template>

<script>
import { APIService } from "@/http/APIService.js";
import jsPDF from "jspdf";

const apiService = new APIService();

export default {
  data: () => ({
    form: {
      score: -1,
      assigned_to_socialny_pracovnik_full: {
        string_details: ""
      },
      assigned_to_pedagog_full: {
        string_details: ""
      },
      assigned_to_psycholog_full: {
        string_details: ""
      },
      assigned_to_pbs_full: {
        string_details: ""
      },
      assigned_to_pripadovy_manazer_full: {
        string_details: ""
      },
      assigned_to_socialny_kurator_full: {
        string_details: ""
      }
    }
  }),

  computed: {
    color() {
      if (this.form.type == "RU") {
        if (this.form.score == -1) return "grey";
        else if (this.form.score <= 24) return "green";
        else if (this.form.score <= 47) return "orange";
        else return "red";
      } else {
        if (this.form.score == -1) return "grey";
        else if (this.form.score <= 23) return "green";
        else if (this.form.score <= 46) return "orange";
        else return "red";
      }
    },

    score_percentage() {
      if (this.form.score == -1) return 0;

      if (this.form.type == "RU")
        return parseFloat((this.form.score / 110) * 100).toFixed(2);
      else return parseFloat((this.form.score / 106) * 100).toFixed(2);
    },

    score_text() {
      if (this.form.type == "RU") {
        if (this.form.score == -1) return "Nie sú vyplnené všetky časti";
        else if (this.form.score <= 24) return "NÍZKE/priaznivá ";
        else if (this.form.score <= 47) return "STREDNÉ/menej priaznivá";
        else return "VYSOKÉ/nepriaznivá";
      } else {
        if (this.form.score == -1) return "Nie sú vyplnené všetky časti";
        else if (this.form.score <= 23) return "NÍZKE/priaznivá ";
        else if (this.form.score <= 46) return "STREDNÉ/menej priaznivá";
        else return "VYSOKÉ/nepriaznivá";
      }
    }
  },

  created() {
    this.getZaver();
  },

  methods: {
    getZaver() {
      apiService.getCraForm(this.$route.params.id).then(response => {
        this.form = response;
      });
    },
    makePdf() {
      var doc = new jsPDF();

      doc.addFont("src/assets/calibri-normal.js", "calibri-normal", "normal");
      doc.setFont("calibri-normal");

      doc.text(
        this.form.prisoner_full.first_name +
          " " +
          this.form.prisoner_full.last_name,
        10,
        10
      );
      doc.text(
        "Základné číslo: " + this.form.prisoner_full.base_number,
        10,
        20
      );

      doc.text("Celkové hodnotenie - počet bodov (min. 0 max. 110):", 10, 30);
      doc.text(
        "Celkové hodnotenie - % vyjadrenie (min. 0 max. 100 %):",
        10,
        40
      );
      doc.text(
        "Riziko recidívy trestnej činnosti/resocializačná prognóza:",
        10,
        50
      );
      doc.text("Poznámky:", 10, 60);

      doc.text("Hodnotitelia:", 10, 70);

      doc.save("a4.pdf");
    }
  }
};
</script>